import lang from '@/lang/middleware/pages/partners';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  const subtitle = store.$i18n.t('jumbotron.subtitle');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
